import React from "react";
import { Mail, FileDown } from "lucide-react";
import MarketingPage, { PageHero } from "../../components/marketing/MarketingPage";

export default function Press() {
  return (
    <MarketingPage
      seo={{
        title: "Press & Media Kit",
        description:
          "Collavue brand assets, boilerplate, and press contact. Everything journalists, partners, and analysts need.",
        path: "/press",
        keywords: "Collavue press, Collavue media kit, Collavue brand assets",
      }}
    >
      <PageHero
        eyebrow="Press"
        title="Press &"
        italicWord="media kit."
        description="Brand assets, boilerplate, and a direct line to our team — everything journalists, partners, and analysts need in one place."
      />

      <section className="bg-white border-t border-[#e3dccb]">
        <div className="max-w-5xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-5">
          <div className="rounded-xl border border-[#e3dccb] p-6 bg-[#faf6ee]/40">
            <FileDown className="w-6 h-6 text-[#2d5bff]" />
            <h2 className="font-display text-2xl text-[#0a1736] font-semibold mt-3">Brand assets</h2>
            <p className="text-[#5a6478] mt-2 leading-relaxed">
              Logos (light & dark), product screenshots, and our official brand colors.
            </p>
            <a
              href="/Collavue.png"
              download
              className="mt-5 inline-flex px-5 py-2.5 rounded-md bg-[#0a1736] text-white text-sm font-medium hover:bg-[#1c2a4d]"
            >
              Download logo
            </a>
          </div>
          <div className="rounded-xl border border-[#e3dccb] p-6 bg-[#faf6ee]/40">
            <Mail className="w-6 h-6 text-[#2d5bff]" />
            <h2 className="font-display text-2xl text-[#0a1736] font-semibold mt-3">Press contact</h2>
            <p className="text-[#5a6478] mt-2 leading-relaxed">
              For interviews, quotes, partnership inquiries, or analyst briefings.
            </p>
            <a
              href="mailto:press@collavue.com"
              className="mt-5 inline-flex px-5 py-2.5 rounded-md bg-white text-[#0a1736] border border-[#e3dccb] text-sm font-medium hover:border-[#0a1736]"
            >
              press@collavue.com
            </a>
          </div>
        </div>

        <div className="max-w-5xl mx-auto px-6 pb-20">
          <h2 className="font-display text-2xl text-[#0a1736] font-semibold">Boilerplate</h2>
          <p className="text-[#5a6478] mt-3 leading-relaxed">
            Collavue is the AI lead discovery and reply layer for B2B teams. Collavue
            scans X (Twitter), LinkedIn, and Reddit for people asking for solutions like yours,
            scores intent, and drafts on-brand replies for human approval. Founded in
            2026 and remote-first.
          </p>
        </div>
      </section>
    </MarketingPage>
  );
}
